import React from "react";
import { Grid, TextField, FormControl, InputLabel } from "@mui/material";
import StageDropdown from "../../../../features/common2/Dropdowns/StageDropdown";
import OutcomeActionDropdown from "../../../../features/common2/Dropdowns/OutcomeActionDropdown";
import PlaybookCadenceDropdown from "../../../../features/common2/Dropdowns/PlaybookCadenceDropdown";
import ColorDropdown from "../../../../features/common2/Dropdowns/ColorDropdown";
import IconDropdown from "../../../../features/common2/Dropdowns/IconDropdown";
import { ActivityTypeOutcome } from "./types/types";
import OutcomeStageList from "../../../../features/outcomes/OutcomeStageList";

type Props = {
    item: ActivityTypeOutcome;
    index: number;
    onUpdateInt: (index: number, prop: string, value: string) => void;
    onUpdateString: (index: number, prop: string, value: string) => void;
    onUpdateBoolean: (index: number, prop: string, value: boolean) => void;
    onUpdateArray: (index: number, prop: string, value: string[]) => void;
};

const OutcomeForm = ({ item, index, onUpdateInt, onUpdateString, onUpdateBoolean, onUpdateArray }: Props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={6} sm={4} md={2}>
                <TextField label="Order" size="small" type="number" value={item.orderBy} onChange={(e) => onUpdateInt(index, 'orderBy', e.target.value)} />
            </Grid>
            <Grid item xs={6} sm={8} md={6}>
                <TextField label="Outcome Name" size="small" fullWidth value={item.name} onChange={(e) => onUpdateString(index, 'name', e.target.value)} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                    <InputLabel>New Stage</InputLabel>
                    <StageDropdown label='New Stage' value={item.newStageId} onChange={(val) => onUpdateString(index, 'newStageId', val)} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                    <InputLabel>Outcome Action</InputLabel>
                    <OutcomeActionDropdown label='Outcome Action' value={item.outcomeActionId} onChange={(val) => onUpdateString(index, 'outcomeActionId', val)} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                    <InputLabel>Playbook Cadence</InputLabel>
                    <PlaybookCadenceDropdown label='Playbook Cadence' value={item.newPlaybookCadenceId} onChange={(val) => onUpdateString(index, 'newPlaybookCadenceId', val)} />
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={3} md={2} lg={2}>
                <FormControl fullWidth>
                    <InputLabel shrink={true}>Color</InputLabel>
                    <ColorDropdown label='Color' value={item.buttonColor} onChange={(val) => onUpdateString(index, 'buttonColor', val)} />
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={3} md={2} lg={2}>
                <FormControl fullWidth>
                    <InputLabel shrink={true}>Icon</InputLabel>
                    <IconDropdown label='Icon' value={item.icon} onChange={(val) => onUpdateString(index, 'icon', val)} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <OutcomeStageList value={item.stages} onChange={(newValue: string[]) => onUpdateArray(index, 'stages', newValue)} />
            </Grid>
        </Grid>
    );
};

export default OutcomeForm;
